import React from "react";
import { Link } from "react-router-dom";

const VARIANTS = {
  primary:
    "bg-primary text-white shadow-lg shadow-primary/30 hover:bg-blue-500 border border-blue-400/40",
  gradient:
    "bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg shadow-purple-500/20 hover:brightness-110",
  secondary:
    "bg-slate-800 text-slate-100 border border-slate-600 hover:bg-slate-700 hover:border-slate-500",
  soft: "bg-primary/15 text-blue-300 border border-primary/30 hover:bg-primary/25",
  danger: "bg-red-500/15 text-red-300 border border-red-500/30 hover:bg-red-500/25",
};

const SIZES = {
  sm: "h-9 px-3 text-xs rounded-xl",
  md: "h-11 px-4 text-sm rounded-xl",
  lg: "h-14 px-6 text-base rounded-2xl",
  icon: "h-14 w-14 rounded-full text-lg",
};

export const buttonClass = ({ variant = "primary", size = "md", block = false, className = "" } = {}) =>
  [
    "inline-flex items-center justify-center gap-2 font-bold transition",
    "active:scale-[.97] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary/40",
    "disabled:opacity-50 disabled:pointer-events-none",
    VARIANTS[variant],
    SIZES[size],
    block ? "w-full" : "",
    className,
  ].join(" ");

/** Кнопка або посилання (якщо передано `to`) в єдиному стилі сайту. */
const Button = ({ variant, size, block, className, to, type = "button", ...props }) => {
  const cls = buttonClass({ variant, size, block, className });
  if (to) return <Link to={to} className={cls} {...props} />;
  return <button type={type} className={cls} {...props} />;
};

export default Button;
